import { Pipe, PipeTransform } from '@angular/core';
import { UploadObj } from '../../classes/upload-obj.class';

// const getUploadProgress = (upload: UploadObj, uploadSpeed: number, concurrency: number): number => {
//   if (upload.progress) return upload.progress;
//   if (!upload.timings?.asset_creation_finished_at) return 0;
//   const timeSinceStart = Date.now() - upload.timings.asset_creation_finished_at;
//   if (!uploadSpeed) return 0;
//   const progress = (((uploadSpeed * timeSinceStart) / upload.file.size) * 100) / concurrency;
//   return Math.max(Math.min(progress, 100), 0);
// };

@Pipe({
  name: 'uploadProgress',
  standalone: true,
  pure: false,
})
export class UploadProgressPipe implements PipeTransform {
  transform(upload: UploadObj): number {
    return upload.progress || 0;
  }
}
